import React, { useState, useEffect } from "react";
import { Box, Text, Flex, UnorderedList, ListItem, Divider, RadioGroup, Radio } from "@chakra-ui/react";
import { PrimaryInput } from "../../components";

const calculateZScore = (observedValue, L, M, S) => {
    if (L === 0) {
        return (observedValue - M) / (S * M);
    }
    return ((Math.pow(observedValue / M, L) - 1) / (L * S));
};

// const GrowthCalculator = ({ growthHeight, growthWeight, ageMonths, onHeightChange, onWeightChange, onAgeChange }) => {
const GrowthCalculator = ({ 
    growthHeight,
  growthWeight,
  ageMonths,
  onHeightChange,
  onWeightChange,
  onAgeChange,
  setZScoreWAZ,
  setZScoreHAZ,
  setZScoreWHZ,
  setStunting,
  setWasting,
  setUnderweight,
}) => {
    // State for Z-scores and statuses
    const [zScWAZ, setZScWAZ] = useState(null);
    const [zScHAZ, setZScHAZ] = useState(null);
    const [zScWHZ, setZScWHZ] = useState(null);
    const [stunt, setStunt] = useState("");
    const [wast, setWast] = useState("");
    const [underweig, setUnderweig] = useState("");
    // const [zScoreWAZ, setZScoreWAZ] = useState(null);
    // const [zScoreHAZ, setZScoreHAZ] = useState(null);
    // const [zScoreWHZ, setZScoreWHZ] = useState(null);
    // const [stunting, setStunting] = useState("");
    // const [wasting, setWasting] = useState("");
    // const [underweight, setUnderweight] = useState("");

    // WHO LMS values (replace with actual values for the given age & gender)
    const L_WAZ = -0.3521, M_WAZ = 3.4, S_WAZ = 0.09182; // Weight-for-Age
    const L_HAZ = -0.3521, M_HAZ = 75, S_HAZ = 0.09182; // Height-for-Age
    const L_WHZ = -0.3833, M_WHZ = 15.2, S_WHZ = 0.0952; // Weight-for-Height

    // Function to calculate Z-scores and update statuses
    const calculateZScores = () => {
        if (growthHeight && growthWeight && ageMonths) {
            const WAZ = calculateZScore(growthWeight, L_WAZ, M_WAZ, S_WAZ);
            const HAZ = calculateZScore(growthHeight, L_HAZ, M_HAZ, S_HAZ);
            const WHZ = calculateZScore(growthWeight, L_WHZ, M_WHZ, S_WHZ);

            setZScoreWAZ(WAZ.toFixed(2));
            setZScoreHAZ(HAZ.toFixed(2));
            setZScoreWHZ(WHZ.toFixed(2));

            setZScWAZ(WAZ.toFixed(2));
            setZScHAZ(HAZ.toFixed(2));
            setZScWHZ(WHZ.toFixed(2));

            setStunting(HAZ < -2 ? "Stunted" : "Normal");
            setWasting(WHZ < -2 ? "Wasted" : "Normal");
            setUnderweight(WAZ < -2 ? "Underweight" : "Normal");

            setStunt(HAZ < -2 ? "Stunted" : "Normal");
            setWast(WHZ < -2 ? "Wasted" : "Normal");
            setUnderweig(WAZ < -2 ? "Underweight" : "Normal");
        }
    };

    // Trigger Z-score calculation whenever height, weight, or age changes
    useEffect(() => {
        calculateZScores();
    }, [growthHeight, growthWeight, ageMonths]);

    return (
        <Box w="100%">
            <Text fontSize="0.875rem" fontWeight="500" color="#7c7c7c" mb="0.5rem">
                According to the WHO Growth Standards
            </Text>
            <Flex flexDir="column" gap="0.75rem">
                {/* Height Input */}
                <Flex justifyContent="space-between" alignItems="center" gap="0.75rem">
                    <Text fontSize="0.875rem">Height (in cm):</Text>
                    <PrimaryInput
                        inputPlace="Enter height (cm)"
                        variant="fullRound"
                        inputStyleCss={{ width: "150px" }}
                        inputValue={growthHeight}
                        onChange={onHeightChange}
                    />
                </Flex>
                <Divider />

                {/* Weight Input */}
                <Flex justifyContent="space-between" alignItems="center" gap="0.75rem">
                    <Text fontSize="0.875rem">Weight (in kg):</Text>
                    <PrimaryInput
                        inputPlace="Enter weight (kg)"
                        variant="fullRound"
                        inputStyleCss={{ width: "150px" }}
                        inputValue={growthWeight}
                        onChange={onWeightChange}
                    />
                </Flex>
                {/* <Divider /> */}

                {/* Age Input */}
                {/* <Flex justifyContent="space-between" alignItems="center" gap="0.75rem">
          <Text fontSize="0.875rem">Age (in months):</Text>
          <PrimaryInput
            inputPlace="Enter age (months)"
            variant="fullRound"
            inputStyleCss={{ width: "150px" }}
            inputValue={ageMonths}
            onChange={onAgeChange}
          />
        </Flex> */}
                <Divider />

                {/* Z-Scores and Statuses */}
                <Box>
                    <Text fontSize="0.875rem" fontWeight="600">Z-Scores (WHO Growth Standards):</Text>
                    <UnorderedList styleType="disc" pl={{ base: "1rem", md: "1.5rem" }} spacing="0.75rem">
                        <ListItem>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                <Text fontSize="0.875rem">Weight-for-Age (WAZ):</Text>
                                {/* <Text fontSize="0.875rem">{zScoreWAZ}</Text> */}
                                <PrimaryInput
                                    inputPlace="Enter value"
                                    variant="fullRound"
                                    inputStyleCss={{ width: "130px" }}
                                    //   inputValue={nestedSub.answer} 
                                    inputValue={zScWAZ}

                                //  defaultValue={nestedSub.answer}
                                //   onChange={(e) => handleHeightWeightZScores(nestedSub.question, e)}
                                />
                            </Flex>
                        </ListItem>
                        <ListItem>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                <Text fontSize="0.875rem">Height-for-Age (HAZ):</Text>
                                {/* <Text fontSize="0.875rem">{zScoreHAZ}</Text> */}
                                <PrimaryInput
                                    inputPlace="Enter value"
                                    variant="fullRound"
                                    inputStyleCss={{ width: "130px" }}
                                    //   inputValue={nestedSub.answer} 
                                    inputValue={zScHAZ}

                                //  defaultValue={nestedSub.answer}
                                //   onChange={(e) => handleHeightWeightZScores(nestedSub.question, e)}
                                />
                            </Flex>
                        </ListItem>
                        <ListItem>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                <Text fontSize="0.875rem">Weight-for-Height (WHZ):</Text>
                                {/* <Text fontSize="0.875rem">{zScoreWHZ}</Text> */}

                                <PrimaryInput
                                    inputPlace="Enter value"
                                    variant="fullRound"
                                    inputStyleCss={{ width: "130px" }}
                                    //   inputValue={nestedSub.answer} 
                                    inputValue={zScWHZ}
                                />
                            </Flex>
                        </ListItem>
                    </UnorderedList>
                </Box>

                {/* Statuses */}
                <Box>
                    {/* <Text fontSize="0.875rem" fontWeight="600">Status:</Text> */}
                    <UnorderedList styleType="disc" pl={{ base: "1rem", md: "1.5rem" }} spacing="0.75rem">
                        <ListItem>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                <Text fontSize="0.875rem">{"Stunting (HAZ < -2):"}</Text>
                                {/* <Text fontSize="0.875rem">{stunting}</Text> */}

                                {/* <RadioGroup colorScheme='green' defaultChecked={stunting} value={stunting} 
                display="flex" gap="1rem">
                                                        <Radio value={stunting} >
                                                          <Text fontSize="0.875rem">Normal</Text>
                                                        </Radio>
                                                        <Radio value={stunting} >
                                                          <Text fontSize="0.875rem">Stunted</Text>
                                                        </Radio>
                                                    </RadioGroup> */}

                                <RadioGroup colorScheme="green" value={stunt} display="flex" gap="1rem">
                                    <Radio value="Normal">
                                        <Text fontSize="0.875rem">Normal</Text>
                                    </Radio>
                                    <Radio value="Stunted">
                                        <Text fontSize="0.875rem">Stunted</Text>
                                    </Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                        <ListItem>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                <Text fontSize="0.875rem">{"Wasting (WHZ < -2):"}</Text>
                                {/* <Text fontSize="0.875rem">{wasting}</Text> */}
                                <RadioGroup colorScheme="green" value={wast} display="flex" gap="1rem">
                                    <Radio value="Normal">
                                        <Text fontSize="0.875rem">Normal</Text>
                                    </Radio>
                                    <Radio value="Wasted">
                                        <Text fontSize="0.875rem">Wasted</Text>
                                    </Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                        <ListItem>
                            <Flex flexDir={{ base: "column", md: "row" }} justifyContent={{ base: "flex-start", md: "space-between" }} alignItems={{ base: "flex-start", md: "center" }} gap={{ base: "0.5rem", md: "0" }}>
                                <Text fontSize="0.875rem">{"Underweight (WAZ < -2):"}</Text>
                                {/* <Text fontSize="0.875rem">{underweight}</Text> */}
                                <RadioGroup colorScheme="green" value={underweig} display="flex" gap="1rem">
                                    <Radio value="Normal">
                                        <Text fontSize="0.875rem">Normal</Text>
                                    </Radio>
                                    <Radio value="Underweight">
                                        <Text fontSize="0.875rem">Underweight</Text>
                                    </Radio>
                                </RadioGroup>
                            </Flex>
                        </ListItem>
                    </UnorderedList>
                </Box>
            </Flex>
        </Box>
    );
};

export default GrowthCalculator;